import WhatsAppIcon from "@/components/WhatsAppIcon";
import { WHATSAPP_URL } from "@/lib/site";

export default function WhatsAppFloat() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with Ishaan Worldlink on WhatsApp"
            data-testid="whatsapp-float"
            className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/25 transition-transform duration-300 hover:scale-105"
        >
            <WhatsAppIcon className="h-7 w-7" />
        </a>
    );
}
